import router from '@/router'

import CheckAPI from '@/api'

export default {
	logoutUser({commit}, payload) {
		if (localStorage.getItem('token')) {
			localStorage.removeItem('token')
		}
		router.push({path: '/login'})
		commit('authStatusChange', payload)
	},

	authStatusLogout({commit}, payload) {
		if (localStorage.getItem('token')) {
			localStorage.removeItem('token')
		}
		commit('authStatusLogout', payload)
	},

	async loginUser({ commit }, payload) {
		const result = await CheckAPI.authenticate({
			'email': payload.email,
			'password': payload.password
		})
		if (200 === result.status) {
			commit('authStatusChange', true);
			router.push('/?page=1');
		} else {
			return new Error(result.data.message)
		}
	},

	getUsers({commit}, payload) {
		//api call here
		commit('getUsers', payload);
	}
}
